<template>
<v-layout row justify-center>
   <v-dialog
      v-model="dialog"
    >
    <v-layout class="dialog-container" row justify-center>
      <v-card max-width="300" width="300">
        <v-card-text class="text-h5">
          <v-layout justify-center>
            <h2>
              Impressora off-line
            </h2>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              color="primary"
              round
              depressed
              class="normal-text"
              @click="reloadPage"
            >
              Tentar novamente
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-layout>
    </v-dialog>
</v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    reloadPage () {
      document.location.reload(true)
    }
  }
}
</script>